(function () {
    "use strict";

    var panel;
    var overlay;
    var closeButton;
    var form;
    var input;
    var clearButton;
    var initialState;
    var loadingState;
    var resultsContainer;
    var statusElement;
    var answerSection;
    var answerContainer;
    var productsSection;
    var productsContainer;
    var collectionsSection;
    var collectionsContainer;
    var resourcesSection;
    var resourcesContainer;
    var emptyState;
    var viewAllLink;

    var searchTimer = null;
    var activeRequest = null;
    var lastFocusedElement = null;
    var minimumCharacters = 2;


    var curatedAnswers =
    (window.CabjaksSearchConfig &&
        window.CabjaksSearchConfig.curatedAnswers) || [];


    /* =====================================================
       INITIAL SETUP
       ===================================================== */

    function initialiseSearch() {
        panel = document.getElementById("CabjaksSearchPanel");

        if (!panel) {
            return;
        }

        overlay = document.getElementById("CabjaksSearchOverlay");
        closeButton = document.getElementById("CabjaksSearchClose");
        form = document.getElementById("CabjaksSearchForm");
        input = document.getElementById("CabjaksSearchInput");
        clearButton = document.getElementById("CabjaksSearchClear");
        initialState = document.getElementById("CabjaksSearchInitial");
        loadingState = document.getElementById("CabjaksSearchLoading");
        resultsContainer = document.getElementById("CabjaksSearchResults");
        statusElement = document.getElementById("CabjaksSearchStatus");

        answerSection = document.getElementById(
            "CabjaksSearchAnswerSection"
        );
        answerContainer = document.getElementById(
            "CabjaksSearchAnswer"
        );

        productsSection = document.getElementById(
            "CabjaksSearchProductsSection"
        );
        productsContainer = document.getElementById(
            "CabjaksSearchProducts"
        );

        collectionsSection = document.getElementById(
            "CabjaksSearchCollectionsSection"
        );
        collectionsContainer = document.getElementById(
            "CabjaksSearchCollections"
        );

        resourcesSection = document.getElementById(
            "CabjaksSearchResourcesSection"
        );
        resourcesContainer = document.getElementById(
            "CabjaksSearchResources"
        );

        emptyState = document.getElementById("CabjaksSearchEmpty");
        viewAllLink = document.getElementById("CabjaksSearchViewAll");

        bindSearchEvents();
        showInitialState();
        initialiseSearchPageAnswer();
    }

    function initialiseSearchPageAnswer() {
        var section = document.getElementById(
            "CabjaksSearchPageAnswerSection"
        );
        var container = document.getElementById(
            "CabjaksSearchPageAnswer"
        );

        if (!section || !container) {
            return;
        }

        var query = section.getAttribute("data-search-query") || "";
        var answer = findCuratedAnswer(query);

        if (!answer) {
            return;
        }

        var link = document.createElement("a");
        var icon = document.createElement("span");
        var content = document.createElement("span");
        var title = document.createElement("span");
        var description = document.createElement("span");
        var action = document.createElement("span");

        link.className = "cabjaks-search-answer";
        link.href = answer.url;

        icon.className = "cabjaks-search-answer__icon";
        icon.setAttribute("aria-hidden", "true");
        icon.textContent = answer.icon || "→";

        title.className = "cabjaks-search-answer__title";
        title.textContent = answer.title;

        description.className = "cabjaks-search-answer__description";
        description.textContent = answer.description;

        action.className = "cabjaks-search-answer__action";
        action.textContent = "View information →";

        content.appendChild(title);
        content.appendChild(description);

        link.appendChild(icon);
        link.appendChild(content);
        link.appendChild(action);

        container.replaceChildren(link);
        section.hidden = false;
    }
    function bindSearchEvents() {
        document.addEventListener("click", function (event) {
            var openTrigger = event.target.closest(
                "[data-cabjaks-search-open]"
            );

            if (openTrigger) {
                event.preventDefault();
                openSearch(openTrigger);
                return;
            }

            if (
                panel.classList.contains("is-open") &&
                !event.target.closest("#CabjaksSearchPanel") &&
                !event.target.closest("[data-cabjaks-search-open]")
            ) {
                closeSearch();
            }
        });

        closeButton.addEventListener("click", closeSearch);
        overlay.addEventListener("click", closeSearch);

        clearButton.addEventListener("click", function () {
            input.value = "";
            clearButton.hidden = true;

            cancelCurrentSearch();
            showInitialState();

            input.focus();
        });

        input.addEventListener("input", handleSearchInput);

        form.addEventListener("submit", function (event) {
            if (!input.value.trim()) {
                event.preventDefault();
                input.focus();
            }
        });

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && panel.classList.contains("is-open")) {
                closeSearch();
            }
        });
    }


    /* =====================================================
       OPEN AND CLOSE
       ===================================================== */

    function openSearch(trigger) {
        lastFocusedElement = trigger || document.activeElement;

        closeMegaNavigation();

        panel.classList.add("is-open");
        overlay.classList.add("is-open");

        panel.setAttribute("aria-hidden", "false");
        overlay.setAttribute("aria-hidden", "false");

        document
            .querySelectorAll("[data-cabjaks-search-open]")
            .forEach(function (button) {
                button.setAttribute("aria-expanded", "true");
            });

        if (window.innerWidth <= 1023) {
            document.body.classList.add("cabjaks-search-is-open");
        }

        window.setTimeout(function () {
            input.focus();
        }, 180);
    }


    function closeSearch() {
        if (!panel.classList.contains("is-open")) {
            return;
        }

        panel.classList.remove("is-open");
        overlay.classList.remove("is-open");

        panel.setAttribute("aria-hidden", "true");
        overlay.setAttribute("aria-hidden", "true");

        document
            .querySelectorAll("[data-cabjaks-search-open]")
            .forEach(function (button) {
                button.setAttribute("aria-expanded", "false");
            });

        document.body.classList.remove("cabjaks-search-is-open");

        cancelCurrentSearch();

        if (
            lastFocusedElement &&
            typeof lastFocusedElement.focus === "function"
        ) {
            lastFocusedElement.focus();
        }
    }


    function closeMegaNavigation() {
        document
            .querySelectorAll(".mega-nav-panel")
            .forEach(function (menuPanel) {
                menuPanel.style.display = "none";
            });

        document
            .querySelectorAll(".mega-nav-trigger")
            .forEach(function (trigger) {
                trigger.classList.remove("is-active");
                trigger.setAttribute("aria-expanded", "false");

                var idleIcon = trigger.querySelector(".on-idle");
                var hoverIcon = trigger.querySelector(".on-hover");

                if (idleIcon) {
                    idleIcon.style.display = "";
                }

                if (hoverIcon) {
                    hoverIcon.style.display = "none";
                }
            });
    }


    /* =====================================================
       INPUT AND REQUEST HANDLING
       ===================================================== */

    function handleSearchInput() {
        var query = input.value.trim();

        clearButton.hidden = query.length === 0;

        window.clearTimeout(searchTimer);
        cancelCurrentSearch();

        if (query.length < minimumCharacters) {
            showInitialState();
            return;
        }

        searchTimer = window.setTimeout(function () {
            performSearch(query);
        }, 250);
    }


    function cancelCurrentSearch() {
        window.clearTimeout(searchTimer);

        if (activeRequest) {
            activeRequest.abort();
            activeRequest = null;
        }
    }


    function performSearch(query) {
        var answer = findCuratedAnswer(query);
        var controller = new AbortController();
        var requestUrl = buildPredictiveSearchUrl(query);

        activeRequest = controller;

        showLoadingState();

        fetch(requestUrl, {
            method: "GET",
            headers: {
                Accept: "application/json"
            },
            signal: controller.signal
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Search request failed");
                }

                return response.json();
            })
            .then(function (data) {
                activeRequest = null;
                renderSearchResults(query, data, answer);
            })
            .catch(function (error) {
                if (error.name === "AbortError") {
                    return;
                }

                activeRequest = null;
                renderSearchResults(query, null, answer);
            });
    }


    function buildPredictiveSearchUrl(query) {
        var parameters = new URLSearchParams();

        parameters.set("q", query);
        parameters.set(
            "resources[type]",
            "product,collection,page,article"
        );
        parameters.set("resources[limit]", "8");
        parameters.set(
            "resources[options][unavailable_products]",
            "hide"
        );
        parameters.set(
            "resources[options][fields]",
            "title,product_type,tag,variants.title,body"
        );

        return "/search/suggest.json?" + parameters.toString();
    }


    /* =====================================================
       CURATED ANSWER MATCHING
       ===================================================== */

    function normaliseQuery(value) {
        return value
            .toLowerCase()
            .replace(/[^\w\s-]/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    }


    function findCuratedAnswer(query) {
        var normalisedQuery = normaliseQuery(query);
        var bestAnswer = null;
        var bestScore = 0;

        curatedAnswers.forEach(function (answer) {
            var score = 0;

            answer.keywords.forEach(function (keyword) {
                var normalisedKeyword = normaliseQuery(keyword);

                if (normalisedQuery === normalisedKeyword) {
                    score += 100 + normalisedKeyword.length;
                } else if (
                    normalisedQuery.indexOf(normalisedKeyword) !== -1
                ) {
                    score += 20 + normalisedKeyword.length;
                } else {
                    var queryWords = normalisedQuery.split(" ");
                    var keywordWords = normalisedKeyword.split(" ");
                    var matchingWords = 0;

                    keywordWords.forEach(function (word) {
                        if (
                            word.length > 2 &&
                            queryWords.indexOf(word) !== -1
                        ) {
                            matchingWords += 1;
                        }
                    });

                    if (
                        matchingWords > 0 &&
                        matchingWords === keywordWords.length
                    ) {
                        score += matchingWords * 5;
                    }
                }
            });

            if (score > bestScore) {
                bestScore = score;
                bestAnswer = answer;
            }
        });

        return bestScore >= 5 ? bestAnswer : null;
    }


    /* =====================================================
       RESULT RENDERING
       ===================================================== */

    function renderSearchResults(query, data, answer) {
                var results =
                    data &&
                    data.resources &&
                    data.resources.results
                        ? data.resources.results
                        : {};

                var normalisedQuery = normaliseQuery(query);

                var seenProductKeys = new Set();

                var products = filterProducts(results.products || [])
                    .filter(function (product) {
                        var key = product.id || product.url;

                        if (!key) {
                            return true;
                        }

                        key = String(key);

                        if (seenProductKeys.has(key)) {
                            return false;
                        }

                        seenProductKeys.add(key);
                        return true;
                    })
                    .map(function (product, index) {
                var title = normaliseQuery(product.title || "");
                var rank = 2;

                if (title === normalisedQuery) {
                    rank = 0;
                } else if (title.indexOf(normalisedQuery) !== -1) {
                    rank = 1;
                }

                return {
                    product: product,
                    rank: rank,
                    originalIndex: index
                };
            })
            .sort(function (a, b) {
                return a.rank - b.rank ||
                    a.originalIndex - b.originalIndex;
            })
            .map(function (result) {
                return result.product;
            })
            .slice(0, 6);
        var collections = (results.collections || []).slice(0, 5);
        var pages = (results.pages || []).slice(0, 5);
        var articles = (results.articles || []).slice(0, 5);
        var seenResourceUrls = new Set();

        var resources = pages.concat(articles)
            .filter(function (item) {
                if (!item.url || seenResourceUrls.has(item.url)) {
                    return false;
                }

                seenResourceUrls.add(item.url);
                return true;
            })
            .map(function (item, index) {
            var title = normaliseQuery(item.title || "");
            var rank = 2;

            if (title === normalisedQuery) {
                rank = 0;
            } else if (title.indexOf(normalisedQuery) !== -1) {
                rank = 1;
            }

            return {
                item: item,
                rank: rank,
                originalIndex: index
            };
        })
        .sort(function (a, b) {
            return a.rank - b.rank ||
                a.originalIndex - b.originalIndex;
        })
        .map(function (result) {
            return result.item;
        })
        .slice(0, 7);

        clearRenderedResults();

        if (answer) {
            renderCuratedAnswer(answer);
        }

        if (products.length) {
            renderProducts(products);
        }

        if (collections.length) {
            renderLinkResults(
                collections,
                collectionsContainer,
                collectionsSection
            );
        }

        if (resources.length) {
            renderLinkResults(
                resources,
                resourcesContainer,
                resourcesSection
            );
        }

        var hasResults =
            Boolean(answer) ||
            products.length > 0 ||
            collections.length > 0 ||
            resources.length > 0;

        emptyState.hidden = hasResults;

        viewAllLink.href =
            "/search?q=" + encodeURIComponent(query);

        initialState.hidden = true;
        loadingState.hidden = true;
        resultsContainer.hidden = false;

        var resultCount =
            products.length +
            collections.length +
            resources.length +
            (answer ? 1 : 0);

        statusElement.textContent =
            resultCount > 0
                ? resultCount + " search suggestions available."
                : "No matching suggestions found.";
    }


    function clearRenderedResults() {
        answerContainer.innerHTML = "";
        productsContainer.innerHTML = "";
        collectionsContainer.innerHTML = "";
        resourcesContainer.innerHTML = "";

        answerSection.hidden = true;
        productsSection.hidden = true;
        collectionsSection.hidden = true;
        resourcesSection.hidden = true;
        emptyState.hidden = true;
    }


    function renderCuratedAnswer(answer) {
        var link = document.createElement("a");
        var icon = document.createElement("span");
        var content = document.createElement("span");
        var title = document.createElement("span");
        var description = document.createElement("span");
        var action = document.createElement("span");

        link.className = "cabjaks-search-answer";
        link.href = answer.url;

        icon.className = "cabjaks-search-answer__icon";
        icon.setAttribute("aria-hidden", "true");
        icon.textContent = answer.icon;

        title.className = "cabjaks-search-answer__title";
        title.textContent = answer.title;

        description.className =
            "cabjaks-search-answer__description";
        description.textContent = answer.description;

        action.className = "cabjaks-search-answer__action";
        action.textContent = "View information →";

        content.appendChild(title);
        content.appendChild(description);

        link.appendChild(icon);
        link.appendChild(content);
        link.appendChild(action);

        answerContainer.appendChild(link);
        answerSection.hidden = false;
    }


    function filterProducts(products) {
        return products.filter(function (product) {
            var tags = Array.isArray(product.tags)
                ? product.tags.map(function (tag) {
                      return String(tag).toLowerCase();
                  })
                : [];

            var productType = String(
                product.product_type || ""
            ).toLowerCase();

            var hasHiddenTag = tags.indexOf("hidden") !== -1;
            var hasColourTag = tags.indexOf("colour") !== -1;
            var isUpgrade = productType === "upgrades";
            var isCustomBenchtop =
                productType === "custom benchtops";

            return !(
                hasHiddenTag ||
                hasColourTag ||
                isUpgrade ||
                isCustomBenchtop
            );
        });
    }


    function renderProducts(products) {
        products.forEach(function (product) {
            productsContainer.appendChild(
                createProductResult(product)
            );
        });

        productsSection.hidden = false;
    }


    function createProductResult(product) {
        var link = document.createElement("a");
        var imageWrapper = document.createElement("span");
        var content = document.createElement("span");
        var title = document.createElement("span");
        var price = document.createElement("span");
        var imageUrl = getProductImage(product);

        link.className = "cabjaks-search-product";
        link.href = getProductUrl(product);

        imageWrapper.className =
            "cabjaks-search-product__image";

        if (imageUrl) {
            var image = document.createElement("img");

            image.src = imageUrl;
            image.alt =
                product.featured_image &&
                product.featured_image.alt
                    ? product.featured_image.alt
                    : product.title || "";

            image.loading = "lazy";
            imageWrapper.appendChild(image);
        }

        title.className = "cabjaks-search-product__title";
        title.textContent = product.title || "View product";

        price.className = "cabjaks-search-product__price";
        price.textContent = formatProductPrice(product);

        content.appendChild(title);

        if (price.textContent) {
            content.appendChild(price);
        }

        link.appendChild(imageWrapper);
        link.appendChild(content);

        return link;
    }


    function getProductUrl(product) {
        var productType = String(
            product.product_type || ""
        ).toLowerCase();

        if (productType === "benchtops") {
            return "/collections/custom-benchtops";
        }

        return product.url || "#";
    }


    function getProductImage(product) {
        if (
            product.featured_image &&
            product.featured_image.url
        ) {
            return product.featured_image.url;
        }

        if (
            product.featured_image &&
            product.featured_image.src
        ) {
            return product.featured_image.src;
        }

        if (typeof product.image === "string") {
            return product.image;
        }

        if (product.image && product.image.url) {
            return product.image.url;
        }

        return "";
    }


    function formatProductPrice(product) {
        var price =
            product.price_min ||
            product.price ||
            "";

        if (price === "" || price === null) {
            return "";
        }

        if (
            typeof price === "string" &&
            /[$£€]/.test(price)
        ) {
            return product.price_varies
                ? "From " + price
                : price;
        }

        var numericPrice = Number(price);

        if (Number.isNaN(numericPrice)) {
            return String(price);
        }

        var formattedPrice;

        try {
            formattedPrice = new Intl.NumberFormat(
                "en-NZ",
                {
                    style: "currency",
                    currency: "NZD"
                }
            ).format(numericPrice);
        } catch (error) {
            formattedPrice =
                "$" + numericPrice.toFixed(2);
        }

        return product.price_varies
            ? "From " + formattedPrice
            : formattedPrice;
    }


    function renderLinkResults(
        items,
        container,
        section
    ) {
        items.forEach(function (item) {
            var link = document.createElement("a");

            link.className = "cabjaks-search-link-result";
            link.href = item.url || "#";
            link.textContent = item.title || "View result";

            container.appendChild(link);
        });

        section.hidden = false;
    }


    /* =====================================================
       VIEW STATES
       ===================================================== */

    function showInitialState() {
        clearRenderedResults();

        initialState.hidden = false;
        loadingState.hidden = true;
        resultsContainer.hidden = true;

        statusElement.textContent = "";
    }


    function showLoadingState() {
        initialState.hidden = true;
        loadingState.hidden = false;
        resultsContainer.hidden = true;

        statusElement.textContent = "Searching Cabjaks.";
    }


    /* =====================================================
       START
       ===================================================== */

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initialiseSearch
        );
    } else {
        initialiseSearch();
    }
})();